export const DAY = 'day';
export const WEEK = 'week';
export const MONTH = 'month';
export const FORECAST = 'forecast';
export const AGENDA = 'agenda';

export const all = [DAY, WEEK, MONTH, FORECAST, AGENDA];
